import { createTypes, createAction } from "lib/action";

const LOAD_VEHICLETYPE_CONFIG = createTypes("vehicletypeconfig", "load");
const SHOW_VEHICLETYPE_CONFIG = createTypes("vehicletypeconfig", "show");
const CREATE_VEHICLETYPE_CONFIG = createTypes("vehicletypeconfig", "create");
const UPDATE_VEHICLETYPE_CONFIG = createTypes("vehicletypeconfig", "update");
const DELETE_VEHICLETYPE_CONFIG = createTypes("vehicletypeconfig", "delete");
const IMPORT_VEHICLETYPE_CONFIG = createTypes("vehicletypeconfig", "import");
const EXPORT_VEHICLETYPE_CONFIG = createTypes("vehicletypeconfig", "export");

const loadVehicleTypeConfigs = {
  request: (params, token) => createAction(LOAD_VEHICLETYPE_CONFIG.REQUEST, { params, token }),
  success: data => createAction(LOAD_VEHICLETYPE_CONFIG.SUCCESS, { data }),
  failure: err => createAction(LOAD_VEHICLETYPE_CONFIG.FAILURE, { err }),
};

const showVehicleTypeConfig = {
  request: (id, token) => createAction(SHOW_VEHICLETYPE_CONFIG.REQUEST, { id, token }),
  success: data => createAction(SHOW_VEHICLETYPE_CONFIG.SUCCESS, { data }),
  failure: err => createAction(SHOW_VEHICLETYPE_CONFIG.FAILURE, { err }),
};

const createVehicleTypeConfig = {
  request: (params, token) => createAction(CREATE_VEHICLETYPE_CONFIG.REQUEST, { params, token }),
  success: data => createAction(CREATE_VEHICLETYPE_CONFIG.SUCCESS, { data }),
  failure: err => createAction(CREATE_VEHICLETYPE_CONFIG.FAILURE, { err }),
};

const updateVehicleTypeConfig = {
  request: (params, id, token) => createAction(UPDATE_VEHICLETYPE_CONFIG.REQUEST, { params, id, token }),
  success: data => createAction(UPDATE_VEHICLETYPE_CONFIG.SUCCESS, { data }),
  failure: err => createAction(UPDATE_VEHICLETYPE_CONFIG.FAILURE, { err }),
};

const deleteVehicleTypeConfig = {
  request: (id, token) => createAction(DELETE_VEHICLETYPE_CONFIG.REQUEST, { id, token }),
  success: id => createAction(DELETE_VEHICLETYPE_CONFIG.SUCCESS, { id }),
  failure: err => createAction(DELETE_VEHICLETYPE_CONFIG.FAILURE, { err }),
};

const importVehicleTypeConfig = {
  request: (file, company_id, token) =>
    createAction(IMPORT_VEHICLETYPE_CONFIG.REQUEST, { file, company_id, token }),
  success: (data) => createAction(IMPORT_VEHICLETYPE_CONFIG.SUCCESS, { data }),
  failure: (err) => createAction(IMPORT_VEHICLETYPE_CONFIG.FAILURE, { err }),
};

const exportVehicleTypeConfig = {
  request: (token) => createAction(EXPORT_VEHICLETYPE_CONFIG.REQUEST, { token }),
  success: (data) => createAction(EXPORT_VEHICLETYPE_CONFIG.SUCCESS, { data }),
  failure: (err) => createAction(EXPORT_VEHICLETYPE_CONFIG.FAILURE, { err }),
};


export {
  loadVehicleTypeConfigs,
  showVehicleTypeConfig,
  createVehicleTypeConfig,
  updateVehicleTypeConfig,
  deleteVehicleTypeConfig,
  importVehicleTypeConfig,
  exportVehicleTypeConfig,
  LOAD_VEHICLETYPE_CONFIG,
  SHOW_VEHICLETYPE_CONFIG,
  CREATE_VEHICLETYPE_CONFIG,
  UPDATE_VEHICLETYPE_CONFIG,
  DELETE_VEHICLETYPE_CONFIG,
  EXPORT_VEHICLETYPE_CONFIG,
  IMPORT_VEHICLETYPE_CONFIG
};
